if (!customElements.get('c-kit-embed')) {
  class CKitEmbed extends HTMLElement {
    connectedCallback() {
      this.destroyed = false;
      this.started = false;
      this.pages = (this.dataset.pages || '').split('|').filter(Boolean);
      this.variantIds = (this.dataset.variantIds || '').split(',').filter(Boolean);
      this.body = this.querySelector('.c-kit-embed__body');
      this.wrap = this.closest('.c-kit-embed') || this;
      this.autoQ = this.dataset.autoQ || '';
      if ((!this.pages.length && !this.autoQ) || !this.variantIds.length) {
        this.hideAll();
        return;
      }
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          if (entries.some((en) => en.isIntersecting)) this.start();
        }, { rootMargin: '600px 0px' });
        this.io.observe(this);
      } else {
        this.start();
      }
    }

    disconnectedCallback() {
      this.destroyed = true;
      if (this.io) this.io.disconnect();
    }

    // Add kit pages found through Shopify predictive search (pages whose title matches the keyword).
    async discoverPages() {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const key = 'c-kit-embed:' + this.autoQ;
      let urls = null;
      try {
        urls = JSON.parse(window.sessionStorage.getItem(key) || 'null');
      } catch (err) { /* storage unavailable */ }
      if (!Array.isArray(urls)) {
        urls = [];
        try {
          const q = encodeURIComponent(this.autoQ);
          const res = await fetch(`${root}search/suggest.json?q=${q}&resources[type]=page&resources[limit]=10`, { headers: { Accept: 'application/json' } });
          if (res.ok) {
            const data = await res.json();
            const pages = (data.resources && data.resources.results && data.resources.results.pages) || [];
            urls = pages.map((p) => String(p.url || '').split('?')[0]).filter(Boolean);
          }
          window.sessionStorage.setItem(key, JSON.stringify(urls));
        } catch (err) { /* search unavailable */ }
      }
      urls.forEach((u) => {
        if (!this.pages.includes(u)) this.pages.push(u);
      });
    }

    hideAll() {
      this.setAttribute('aria-busy', 'false');
      this.wrap.hidden = true;
    }

    async start() {
      if (this.started) return;
      this.started = true;
      if (this.io) this.io.disconnect();
      if (this.autoQ) await this.discoverPages();
      if (!this.pages.length) {
        this.hideAll();
        return;
      }
      let found = null;
      for (let i = 0; i < this.pages.length; i++) {
        if (this.destroyed) return;
        try {
          const res = await fetch(this.pages[i], { credentials: 'same-origin', headers: { Accept: 'text/html' } });
          if (!res.ok) continue;
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          found = this.findSection(doc);
          if (found) break;
        } catch (err) { /* try the next page */ }
      }
      if (this.destroyed) return;
      if (!found) {
        this.hideAll();
        return;
      }
      this.inject(found);
    }

    findSection(doc) {
      const sections = doc.querySelectorAll('.shopify-section');
      for (let i = 0; i < sections.length; i++) {
        const sec = sections[i];
        if (!sec.querySelector('.c-kitbuilder__root')) continue;
        const ok = this.variantIds.some((id) => !!sec.querySelector('[data-variant-id="' + id + '"]'));
        if (ok) return sec;
      }
      return null;
    }

    inject(sec) {
      if (!this.body) return;
      const holder = document.createElement('div');
      holder.className = 'c-kit-embed__kit';
      holder.innerHTML = sec.innerHTML;
      holder.querySelectorAll('script').forEach((s) => s.remove());
      this.body.textContent = '';
      this.body.appendChild(holder);
      this.setAttribute('aria-busy', 'false');
      this.classList.add('is-loaded');
      this.ensureScript();
      customElements.whenDefined('c-kitbuilder').then(() => {
        if (this.destroyed) return;
        const kit = holder.querySelector('c-kitbuilder');
        if (kit && typeof kit.preselectVariant === 'function') kit.preselectVariant(this.pickVariant());
      });
    }

    ensureScript() {
      if (customElements.get('c-kitbuilder')) return;
      const src = this.dataset.kitScript;
      if (!src) return;
      const abs = new URL(src, window.location.href).href.split('?')[0];
      const existing = Array.prototype.some.call(document.querySelectorAll('script[src]'), (s) => s.src.split('?')[0] === abs);
      if (existing) return;
      const tag = document.createElement('script');
      tag.src = src;
      tag.defer = true;
      document.head.appendChild(tag);
    }

    pickVariant() {
      let id = '';
      try { id = new URLSearchParams(window.location.search).get('variant') || ''; } catch (err) { id = ''; }
      if (id && this.variantIds.indexOf(id) > -1) return id;
      return this.dataset.currentVariant || '';
    }
  }
  customElements.define('c-kit-embed', CKitEmbed);
}
